import * as utils from '../functions/utils';
import * as messageUtils from '../functions/messageUtils';
import { IMainPhoto, IMemberTypeTitle } from '../interfaces/IUser';
import { IFriend, IFriendUserResponse, IParentClub } from '../interfaces/IFriendUser';
import Photo from './photo';

export default class Friend {
  age1: number | null;
  age2: number | null;
  ageTitle: string;
  hasFavourited: boolean;
  hasLiked: boolean;
  isDiamond: boolean;
  isFavourite: boolean;
  isFavouriteMutual: boolean;
  isLikeMutual: boolean;
  isMatch: boolean;
  isOnline: boolean;
  itemDate: string;
  itemID: number | null;
  location: string;
  mainPhoto: IMainPhoto;
  matchingInterests: any;
  userId: number | null;
  memberLevel: any;
  memberType: any;
  memberTypeTitle: IMemberTypeTitle;
  userName: string;
  xmppId: string;
  userType: string;
  isViewable: boolean;
  dateCreated: string;
  parentClub?: IParentClub;

  constructor() {
    this.age1 = null;
    this.age2 = null;
    this.ageTitle = '';
    this.hasFavourited = false;
    this.hasLiked = false;
    this.isDiamond = false;
    this.isFavourite = false;
    this.isFavouriteMutual = false;
    this.isLikeMutual = false;
    this.isMatch = false;
    this.isOnline = false;
    this.itemDate = '';
    this.itemID = null;
    this.location = '';
    this.mainPhoto = {
      fullUrl: '',
      height: null,
      isPublic: false,
      isUserImage: false,
      photoID: null,
      thumbUrl: '',
      width: null,
      imageType: '',
      imageActionType: '',
      showSafeMode: false,
    };
    this.matchingInterests = null;
    this.userId = null;
    this.memberLevel = null;
    this.memberType = null;
    this.memberTypeTitle = {
      abbr: '',
      plural: '',
      singular: '',
    };
    this.userName = '';
    this.xmppId = '';
    this.userType = '';
    this.isViewable = true;
    this.dateCreated = '';
    this.parentClub = undefined;
  }

  static mappingObject(_friend: IFriendUserResponse): IFriend {
    if (_friend) {
      let friend = Object.assign(new Friend(), _friend);
      friend.age1 = _friend.Age1;
      friend.age2 = _friend.Age2;
      friend.ageTitle = _friend.AgeTitle;
      friend.hasFavourited = _friend.HasFavourited;
      friend.hasLiked = _friend.HasLiked;
      friend.isDiamond = _friend.IsDiamond;
      friend.isFavourite = _friend.IsFavourite;
      friend.isFavouriteMutual = _friend.IsFavouriteMutual;
      friend.isLikeMutual = _friend.IsLikeMutual;
      friend.isMatch = _friend.IsMatch;
      friend.isOnline = _friend.IsOnline;
      friend.itemDate = _friend.ItemDate;
      friend.itemID = _friend.ItemID;
      friend.location = _friend.Location;
      friend.mainPhoto = _friend.MainPhoto ? Photo.mappingObject(_friend.MainPhoto) : {};
      friend.matchingInterests = _friend.MatchingInterests;
      friend.userId = _friend.MemberID;
      friend.memberLevel = _friend.MemberLevel;
      friend.memberType = _friend.MemberType;
      friend.memberTypeTitle.abbr = _friend.MemberTypeTitle.Abbr || '';
      friend.memberTypeTitle.plural = _friend.MemberTypeTitle.Plural || '';
      friend.memberTypeTitle.singular = _friend.MemberTypeTitle.Singular || '';
      friend.userName = _friend.UserName;
      friend.userType = _friend.UserType;
      friend.xmppId = messageUtils.removePrefixAndSuffix(_friend.XMPPID || _friend.MemberID?.toString() || '');
      friend.isViewable = _friend.hasOwnProperty('IsViewable') ? _friend.IsViewable! : true;
      friend.dateCreated = _friend.DateListItem || '';
      friend.parentClub = _friend.ParentClub ? { clubId: _friend.ParentClub.ClubID, clubName: _friend.ParentClub.ClubName } : undefined;
      friend = utils.cleanObjectKeys(Object.keys(new Friend()), friend); // clean other key doesn't exist in user model

      return friend;
    }
    return new Friend();
  }

  static mappingObjects(_friends: IFriendUserResponse[]): IFriend[] {
    const friends: IFriend[] = [];
    _friends.forEach(_friend => {
      const friend = Friend.mappingObject(_friend);
      friends.push(friend);
    });
    return friends;
  }
}
